import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
import * as turf from '@turf/turf';
/**
 * 车辆图层
 */
export default class VehicleLayer extends BaseLayer{

    constructor(options= {}){
        options.layerName=options.layerName||CONSTANTS.LAYER.VEHICLE;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.map((item,index) =>{
            self.addEntity(item);
        });
    }

    updateEntities(data){
        let self=this;
        data.map((item,index) =>{
            if(item.longitude&&item.latitude){
                let entity=self.getEntityById(item.id);
                if(entity){
                    let attributes=entity.attributes;
                    //entity.billboard.rotation=turf.bearing(turf.point([attributes.longitude,attributes.latitude]), turf.point([item.longitude,item.latitude]));//图标旋转
                    attributes.factor=0;
                    entity.position=new Cesium.CallbackProperty(()=>{
                        if(attributes.factor<1500){
                            attributes.factor=attributes.factor+1;
                        }else{
                            entity.attributes.longitude=item.longitude;
                            entity.attributes.latitude=item.latitude;
                        }
                        //动态更新位置
                        return Cesium.Cartesian3.lerp(
                            Cesium.Cartesian3.fromDegrees(attributes.longitude,attributes.latitude),
                            Cesium.Cartesian3.fromDegrees(item.longitude,item.latitude),
                            attributes.factor/1500.0,new Cesium.Cartesian3());
                    },false);
                    entity.attributes.pathIndex=item.pathIndex;
                }else{
                    self.addEntity(item);
                }

            }
        });
    }

    addEntity(data){
        let item={...data};
        item.layerName=this.layerName;
        if(item.longitude&&item.latitude){
            let entity=new Cesium.Entity({
                position: Cesium.Cartesian3.fromDegrees(item.longitude,item.latitude, CONSTANTS.ALTITUDE),
                name: item.licensePlate,
                id:item.id,
                attributes:item,
                //立广告牌
                billboard :{
                    image : require("../../img/map/vehicle.png"),
                    show : true,
                    width : 48,
                    height : 48,
                    pixelOffset:new Cesium.Cartesian2(0, 0),
                    heightReference:Cesium.HeightReference.CLAMP_TO_GROUND,
                },
                label:{
                    text : item.licensePlate,
                    style:Cesium.LabelStyle.FILL_AND_OUTLINE,
                    color :Cesium.Color.fromCssColorString('#fff'),
                    backgroundColor:Cesium.Color.fromCssColorString('#26605E'),
                    backgroundPadding:new Cesium.Cartesian2(7, 5),
                    outlineColor:Cesium.Color.fromCssColorString('#2D3635'),
                    outlineWidth:4,
                    font: "16px Helvetica",
                    showBackground : true,
                    pixelOffset:new Cesium.Cartesian2(-6, -36)
                }
            })
            this.dataSource.entities.add(entity);
        }
    }
}
